// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileBulkFollowModal-cls1_64O","cls2":"ProfileBulkFollowModal-cls2_wGW ProfileBulkFollowModal-cls1_64O"};